import React, { Component } from 'react'


export default class BranchForm extends Component{
  constructor (props){
    super(props)
    this.state = {
        branch : this.props.branch
    }
    this.onChangeBranch = this.onChangeBranch.bind(this);
  }

  componentWillReceiveProps(nextProps) {
      if(JSON.stringify(nextProps.branch) !== JSON.stringify(this.props.branch)){
          this.setState({ branch: nextProps.branch });
      }
  }

  onChangeBranch(event) {
    //alert (event.target.name);
    let xname = event.target.name
    if(xname==="branch_name"){
      this.setState ({branch:{
          ...this.state.branch,
          branch_name: event.target.value
        }})
    }else if(xname==="branch_address"){
      this.setState ({branch:{
          ...this.state.branch,
          branch_address: event.target.value
        }})
    }else if(xname==="branch_tel"){
      this.setState ({branch:{
          ...this.state.branch,
          branch_tel: event.target.value
        }})
    }
  }

    render(){
        return (
            <div className="card card-accent-danger">
                <div className="card-header">
                    <strong>เพิ่มสาขา</strong>
                </div>
                <form action="" method="post"
                      onSubmit={ (this.props.actionType==="แก้ไข")? this.props.onBranchSubmit.update :this.props.onBranchSubmit.add  }>

                    <div className="card-block">
                        <div className="form-group">
                            <label htmlFor="branch_name">สาขา </label>
                            <input name="branch_name"
                                   ref="branch_name"
                                   value={this.state.branch.branch_name || ''}
                                   type="text" className="form-control"
                                   id="branch_name"
                                   placeholder="กรอกชื่อสาขา"
                                   onChange={this.onChangeBranch}/>
                        </div>

                        <div className="form-group">
                            <label htmlFor="branch_address">ที่อยู่ </label>
                            <input name="branch_address"
                                   ref="branch_address"
                                   value={this.state.branch.branch_address || ''}
                                   type="text" className="form-control"
                                   id="branch_address"
                                   placeholder="กรอกที่อยู่สาขา"
                                   onChange={this.onChangeBranch}/>
                        </div>

                        <div className="form-group">
                            <label htmlFor="branch_tel">เบอร์โทรศัพท์</label>
                            <input name="branch_tel"
                                   ref="branch_tel"
                                   value={this.state.branch.branch_tel || ''}
                                   type="text" className="form-control"
                                   id="branch_tel"
                                   placeholder="กรอกเบอร์โทรศัพท์"
                                   onChange={this.onChangeBranch}/>
                        </div>
                    </div>

                        <div className="card-footer text-right">
                            <button type="reset" className="btn btn-sm btn-danger"><i className="fa fa-refresh"></i> ยกเลิก</button>
                            <button type="submit" className={this.props.actionType==="แก้ไข"? "btn btn-sm btn-warning" : "btn btn-sm btn-primary"} >
                                <i className={this.props.actionType==="แก้ไข"? "fa fa-edit":"fa fa-save"}></i> {this.props.actionType}</button>
                        </div>

                </form>
            </div>
        );
    }
}
//export  default BranchForm;